// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3IS25","footer":"ModalError_footer__3oSnU"};